import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Proof() {
  return <section className="py-24 md:py-32 bg-[#1A2352] relative border-y border-white/5" data-id="element-210">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#F5D0A9]/5 via-transparent to-transparent opacity-50" data-id="element-211" />
      <div className="container mx-auto px-6 max-w-4xl text-center relative z-10" data-id="element-212">
        <FadeIn data-id="element-213">
          <ShieldCheck className="w-12 h-12 text-[#F5D0A9] mx-auto mb-10 opacity-80" data-id="element-214" />
          <p className="text-2xl md:text-3xl lg:text-4xl font-serif text-white leading-relaxed italic" data-id="element-215">
            "Within the first 7 days, the 'Internal Thermostat' begins to
            recalibrate. You will notice that even if you do wake up, the
            'panic' feeling is gone, and the time it takes to fall back asleep
            drops from 90 minutes to less than 10."
          </p>
        </FadeIn>
      </div>
    </section>;
}